import React from 'react';

import Toggle from '@atlaskit/toggle';

export default function Example(): React.JSX.Element {
	return (
		<>
			<Toggle id="toggle-default" label="Allow pull request" />
		</>
	);
}
